import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import * as Sentry from '@sentry/browser';
import { Replay } from '@sentry/replay';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.sentryEnvironment,
  release: environment.version,

  tracesSampleRate: 0.2,

  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,

  debug: false,

  integrations: [
    new Replay({
      maskAllText: false,
      maskAllInputs: true,
      blockAllMedia: false
    })
  ]
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => {
    console.error(err);
    Sentry.captureException(err);
  });